import { formatPrice } from 'dreamroi-currencies';

export default {
    methods: {
        formatAddress({street, city, zip}) {
            return `${street || this.$t('common.notSet')}, ${city || this.$t('common.notSet')}, ${zip || this.$t('common.notSet')}`;
        },
        formatNumber(n, fixed) {
            if(!n) {
                return '0';
            }
            if(fixed != null) {
                return n.toFixed(fixed);
            }
            return n;
            // TODO use Numeral.js to format nubers according to locale
        },
        formatCurrency(c, sign) {
            /*
            switch(c) {
                case 'CZK':
                    return `Kč (${c})`;
                case 'EUR':
                    return `€ (${c})`;
                case 'USD':
                    return `$ (${c})`;
                default:
                    return c;
            }
            */
            let currency = this.$store.state.domains.currencies.find(cr => cr.value == c);
            return sign ? currency.sign : currency.text; 
        },
        formatCurrencyAmount(value, currency, fixed) {
            /*
            let c = this.$store.state.domains.currencies.find(cr => cr.value == currency);
            if(c.format) {
                return c.format(value);
            }
            return `${this.formatNumber(value, fixed)} ${c.sign}`;
            */
           return formatPrice(currency, this.formatNumber(value, fixed));
        },

        isCurrencyPrefix(currency) {
            return typeof(this.$store.state.domains.currencies.find(cr => cr.value == currency)?.format) == 'function';
        },

        formatTimezone(tz) {
            //return `UTC${tz >= 0 ? '+' : ''}${tz/60}:00`
            return tz.replace(/_/g, ' ');
        },
        formatCountry(v) {
            if(!this.countries) {
                console.error('formatCountry: COUNTRIES MIXIN REQUIRED');
                return v;
            }
            return (this.countries.find(c => c.value == v))?.text;
        },
        formatDate(d, dateOnly, noValueText = this.$t('common.never')) {
            if(!d) {
                return noValueText;
            }
            if(typeof(d) === 'string' || typeof(d) === 'number') {
                d = new Date(d);
            }
            if(d.valueOf() == 0) {
                return noValueText;
            }
            //return dateOnly ? d.toLocaleDateString() : d.toLocaleString();
            return dateOnly ? this.$d(d, 'short') : this.$d(d, 'long');
        },
        formatBoolean(v) {
            return v ? this.$t('common.boolean.true') : this.$t('common.boolean.false');
        },
        getCampaignStateColor(state, type) {
            // INCOMPLETE, WAITING, COMPUTING, SENDING, COMPLETED, DISABLED
            if(!type) {
              type = this.type;
            }
            switch(state) {
              case 'INCOMPLETE': 
                return 'orange';
              case 'WAITING': 
              case 'COMPUTING':
              case 'SENDING':
                return ['SCHEDULED','SWU', 'SMART_WARM_UP'].includes(type?.toUpperCase()) ? 'blue' : 'green';
              case 'COMPLETED':
                return 'green';
              case 'DISABLED':
                  return 'red';
              case 'ARCHIVED':
                  return 'grey';
            }
        },
        getCampaignStateText(state) {
        
            let states = [{ title: this.$t('campaigns.state.incomplete'), value: 'INCOMPLETE' },
                        { title: this.$t('campaigns.state.waiting'), value: 'WAITING' },
                        { title: this.$t('campaigns.state.computing'), value: 'COMPUTING' },
                        { title: this.$t('campaigns.state.sending'), value: 'SENDING' },
                        { title: this.$t('campaigns.state.completed'), value: 'COMPLETED' },
                        { title: this.$t('campaigns.state.paused'), value: 'DISABLED'  },
                        { title: this.$t('campaigns.state.archived'), value: 'ARCHIVED' }];
            return states.find(s => s.value == state)?.title;
        },
        formatPlatform(p) {
            if(!p) {
                return this.$t('common.platform.noPlatform');
            }
            switch(p) {
                case 'WOOCOMMERCE': return 'WooCommerce';
                case 'OTHER': return this.$t('common.platform.other');
                default: return `${p[0]}${p.substr(1).toLowerCase()}`;
            } 
        },
        formatTimeWindow(window) {
            /*
            switch(window) {
                case '7d': return 'Last 7 days';
                case '14d': return 'Last 14 days';
                case '1m': return 'Last month';
                case '3m': return 'Last 3 months';
                case '6m': return 'Last 6 months';
                case '12m': return 'Last year';
            }
            */
           return this.$t(`common.periods.${window}`);
        },
        getVisitorsColor(visitors, limit) {
            if(!limit) {
                return null;
            }
            let ratio = visitors / limit;
            if(ratio < 0.8) {
                return 'green--text';
            } else if(ratio < 1) {
                return 'orange--text';
            } else {
                return 'red--text';
            }
        }
    }
}